import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { PhonePipe } from './phone.pipe';
import { NextDatePipe } from './next-date.pipe';
import { TimeAmPmPipe } from './time-am-pm.pipe';
import { CpfPipe } from './cpf.pipe';
import { CnpjPipe } from './cnpj.pipe';

const pipes = [ExcerptPipe, GetValueByKeyPipe, RelativeTimePipe, PhonePipe, NextDatePipe, TimeAmPmPipe, CpfPipe, CnpjPipe];

@NgModule({
	imports: [CommonModule],
	declarations: pipes,
	exports: pipes
})
export class SharedPipesModule {}
